<div class="security-entry-table">
  <nf-table-layout
    hideTitle
    [isSectionTitle]="false"
    [gridOptions]="gridOptions"
    [data]="rowData"
    hideSearch
    [autoResizeGrid]="false"
    hideClearAll
  ></nf-table-layout>
  <hs-loader
    class="{{ !loadTable ? 'active' : '' }}"
    [loading]="!loadTable"
    [label]="loadingText"
    [errorLabel]="errorText"
    [showText]="!loadTable"
  ></hs-loader>
</div>
